import styled from 'styled-components'

const Container = styled.div`
  width: 420px;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
`

const BottomLinks = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

const Styled = {
  Container,
  BottomLinks
}

export default Styled;